<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import axios from 'axios';
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Income Statement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      filterPurchases: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        title: 'Income Statement'
      },
      title: "Income Statement",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Income Statement",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount:0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      sortDesc: false,

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("general", ["IncomeStatement"]),
  },
  methods: {
    ...mapActions({
      FetchStatement: "general/fetchIncomeStatement",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    IncomeReportData(){
      this.FetchStatement(this.filterPurchases);
    },
     Excel_export() {
      axios
        .post("export_shoppurchases", this.filterPurchases,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          // this.$toast.add({
          //   severity: "success",
          //   summary: "Successful",
          //   detail: "Sales Report Downloaded successfully",
          //   life: 6000,
          // });
          this.spinner = false;
        })
        .catch(() => {
          // this.spinner = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Something wrong",
          //   detail: "Sales Report Download failed",
          //   life: 6000,
          // });
        });
    },
  },
  watch: {
    FetchStatement(newValue){
      if(newValue){
        this.IncomeReportData();
      }
    },
  },
  created() {
    this.FetchStatement(this.filterPurchases);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="filterPurchases.title"></h3>
              </div>

            </div>
            <div class="row">
              <div class="col-md-4 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-4 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="IncomeReportData()"
                  type="date"
                  v-model="filterPurchases.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="IncomeReportData()"
                  v-model="filterPurchases.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">S/No</th>
                    <th scope="col">Particulars</th>
                    <th scope="col">Amount(Shs.)</th>
                    <th scope="col">Amount(Shs.)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Sales</td>
                    <td></td>
                    <td>{{IncomeStatement.total_sales}}</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Less Cost of Sales</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Purchases</td>
                    <td>{{IncomeStatement.total_purchases}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">4</th>
                    <td>Add Opening Stock</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">5</th>
                    <td>Less Closing Stock</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">6</th>
                    <td>Cost of Sales</td>
                    <td></td>
                    <td>{{IncomeStatement.costof_sales}}</td>
                  </tr>
                  <tr>
                    <th scope="row">7</th>
                    <td>Gross Profit</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">8</th>
                    <td>Less Operating Expenses</td>
                    <td></td>
                    <td>{{IncomeStatement.total_expenses}}</td>
                  </tr>
                  <tr>
                    <th scope="row">9</th>
                    <td>Operating Profit</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">10</th>
                    <td>Less Income Tax (30 %)</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">11</th>
                    <td>Net profit/loss</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Loader  v-if="!IncomeStatement"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
